/**
 * @type module
 * Grupuje i wyświetla zaznaczone markery na mapie.
 * Markery po pierwszym wywołaniu funkcji displayMarkers() są cacheowane, dlatego kolejne wywołania funkcji show() nie powodują tworznia nowych markerów.
 * Mechanizm cacheowania omijany jest w przypadku wyszukiwania miast, gdy funkcja show() przyjmuje jako parametr listę lokalizacji. Wywołana zostanie wtedy
 * funckja displayMarkers z argumentem temp = true, co spowoduje utworzenie nowych markerów.
 */
app.service('shopLocatorMap', function( shopLocatorManager, shopLocatorFilters, front ) {
	var gmap, markers = [], markerCluster = [], tempMarkers = [];
	var activeWindow;
	var settings; 

	function deleteMarkers() {
		Object.keys(markerCluster).forEach(function(key) {
			markerCluster[key].clearMarkers();
		});
	}

	function getIcon( item ) {
		return '/img/desktop/' + front.name() + '/' + item.type + '-pin.png';
	}

	function createMarker( item ) {
			var options =	{
				map: gmap,
				position: { lat: +item.location.ltd, lng: +item.location.lgt },
				title: item.city,
				icon: getIcon( item ),
				id: item.code
			};
			return new google.maps.Marker( options );
	}

	function displayMarkers( locations, temp ) {
		var markersConfig = [];
		tempMarkers = [];
		if(temp) {
			var bounds = new google.maps.LatLngBounds();
		}

		locations.forEach( function( item, i ) {

			var infoWindow = new google.maps.InfoWindow();
			infoWindow.setContent( "<div class='info-window'><p><strong>" + item.title + "</strong></p><p>" + item.street + "</p><p><span>" + item.postCode + "</span><span> " + item.city + "</span></p><p>" + item.description + "</p><p>" + item.additionalDescription + "</p><p><a class='btn btn-second' href='#'>Przejdź do strony punktu</a></p></div>" );
			item.type = item.type.toLowerCase();
			if( !markers[ item.type ] ) { // create new cache
				markers[ item.type ] = [];
			}
			var marker = createMarker( item );

			if(temp) {
				tempMarkers.push(marker);
			} else {
				markers[ item.type ].push( marker ); // add new marker to cache
			}
			if( !markersConfig[ item.type ] ) {
				markersConfig[ item.type ] = {
					styles: [{
						url: getIcon( item ),
						width: 40,
						height: 54,
						textSize: 14
					}]
				};
			}
			google.maps.event.addListener(marker, 'click', (function(marker, i) {
				return function() {
					if( activeWindow ) {
						if( activeWindow.anchor && !activeWindow.map) {
							activeWindow.anchor = null;
						}
						activeWindow.close();
					}
					infoWindow.setPosition(marker.position);
					infoWindow.open( gmap, marker );
					activeWindow = infoWindow;
				};
			})(marker, i));
			temp && bounds.extend( marker.position );
		} );

		Object.keys( markersConfig ).forEach(function( key ) {
			if( !markerCluster[ key ] ) {
				markerCluster[ key ] = new MarkerClusterer( gmap, markers[ key ], markersConfig[ key ] );
				google.maps.event.addListener(markerCluster[ key ], 'clusterclick', function() {
					if( activeWindow ) {
						activeWindow.close();
					}
				});
			} else {
				deleteMarkers();
				markerCluster[ key ].addMarkers( tempMarkers );
			}
		});

		if(temp) {
			gmap.fitBounds( bounds );
			gmap.panBy( -150, 0 );
		}

		if( locations.length === 1 ) {
			google.maps.event.trigger( tempMarkers[0], 'click' );
			gmap.setZoom(18);
		}
	}

	function getMarker( id ) {
		var markersArray = [];
		Object.keys( markers ).forEach(function( key ) {
			markersArray = markersArray.concat( markers[ key ] );
		});

		return markersArray.filter( function( marker ) {
			return marker.id === id;
		} )[0];
	}

	function zoomTo( marker ) {
		var marker = ( typeof marker === 'string' ) ? getMarker( marker ) : marker;
		var location = marker.getPosition();
		marker.setMap(gmap);
		gmap.panTo(location);
		gmap.setZoom(18);
		gmap.panBy(-200, 0);

		google.maps.event.addListenerOnce(gmap, 'idle', function() {
			google.maps.event.trigger( marker, 'click' );
		});
	}

	function show( locations, callback ) {
		resetMap();
		if( typeof locations === 'string' ) {
			shopLocatorFilters.getSelected().forEach( function( id ) {
				if( markers[id] ) { // load from cache
					var cachedMarkers = markers[ id ];
					markerCluster[ id ].addMarkers( cachedMarkers );
					callback && callback();
				} else {
					shopLocatorManager.getLocations( locations ).then( function( markers ) {
						if( markers.length )  {
							displayMarkers( markers, false );
							callback && callback();
						}
					} );
				}
			});
			return;
		}
		callback && callback();
		displayMarkers( locations, true );
	}

	function resetMap() {
		deleteMarkers();
		//gmap.setZoom( settings.zoom );
		//gmap.setCenter( settings.center );
	}

	function init( $self ) {
		var map = $self.find('#map')[0];
		settings = {
			center: {
				lat: 51.9614997,
				lng: 18.11389
			},
			zoom: 6,
			scrollwheel: false,
			streetViewControl: false,
			mapTypeControl: false
		};

		if( map ) {
			gmap = new google.maps.Map( map, settings );
		}
	}

	return {
		init: init,
		show: show,
		zoom: zoomTo,
	};
});
